import { useRef } from 'react';

import {
    SectionChevron,
    SectionHeader,
    SectionTitle,
    SectionToggle,
    SUBSECTION_HEADER_HEIGHT_VAR,
} from './ApplicantConditions.StyledComponents';
import { usePublishedHeight } from './usePublishedHeight';

interface CollapsibleSectionHeaderProps {
    title: string;
    isOpen: boolean;
    onToggle: () => void;
    testId: string;
    isSubsection?: boolean;
    children?: React.ReactNode;
}

export const CollapsibleSectionHeader = ({
    title,
    isOpen,
    onToggle,
    testId,
    isSubsection,
    children,
}: CollapsibleSectionHeaderProps) => {
    const headerRef = useRef<HTMLDivElement>(null);
    usePublishedHeight(headerRef, SUBSECTION_HEADER_HEIGHT_VAR, Boolean(isSubsection));

    return (
        <SectionHeader ref={headerRef} $collapsed={!isOpen} $subsection={isSubsection}>
            <SectionToggle
                type="button"
                onClick={onToggle}
                aria-expanded={isOpen}
                data-testid={testId}
            >
                <SectionTitle as="span" $subsection={isSubsection}>
                    <SectionChevron aria-hidden>{isOpen ? '▾' : '▸'}</SectionChevron>
                    {title}
                    {children}
                </SectionTitle>
            </SectionToggle>
        </SectionHeader>
    );
};
